{
  "clear": "Wyczyść",
  "invalid": "(nieprawidłowy)",
  "loading": "Trwa ładowanie...",
  "noResults": "Brak wyników"
}
